import { Typography } from "@mui/material";

export default [
  {
    id: "0001",
    image:
      "https://img.nzz.ch/2018/2/8/f5e461e0-f1bb-4c31-82dd-b7d37de5bfb1.jpeg?width=2813&height=1950&fit=crop&quality=75&auto=webp",
    title: "درآمد",
    text: (
      <p>
        فریدریش ویلهلم نیچه به سالِ ۱۸۴۴ در خانواده‌ای پروتستان و مذهبی چشم به
        جهان گشود. در دورانِ کودکی، پدر-اش را که کشیشی پروتستان بود، از دست داد.
        در سالِ ۱۸۶۵ هنگامی که در رشته‌ی فیلولوژیِ کلاسیک مشغولِ به تحصیل بود،
        با اثرِ مهّمِ شوپنهاور «جهان همچون اراده و تصّور» آشنا شد که تاثیر شگرفی
        در شکل گیریِ اندیشه‌یِ فیلسوفِ جوان ایجاد نمود. علاوه بر شوپنهاور،
        ریچارد واگنر آهنگسازِ آلمانی و مطرحِ قرنِ نوزدهم نیز برای وی شخصیتی
        کاریزماتیک و تحسین‌برانگیز به‌شمار می‌آمد. آخرین و مهم‌ترین سرچشمه‌ی
        الهام بخش برای نیچه اما، فلسفه کلاسیکِ یونان بود. در سالهای بعدی،
        وابستگیِ فکری و فرهنگیِ نیچه از واگنر و شوپنهاور به‌طور کامل از میان
        برداشته شد اما فلسفه یونان، تقریبا در تمامیِ عمر، همراه و الهام بخشِ وی
        باقی ماند.
        <br />
        <br />
        نیچه در سال ۱۹۸۹ دچار فروپاشیِ ذهنی شده و در ۲۵ آگوست ۱۹۰۰ چشم از جهان
        فرو بست. درباره‌ی محورِ اصلیِ اندیشه‌یِ فیلسوف، در همین‌جا و در آغازِ
        این سلسله نوشتار، اشاره به این نکته ضروری می نماید که برخلاف اندیشه و
        باورِ عمومی که کتابِ «چنین گفت زرتشت» را به عنوانِ اثرِ اصلی و اندیشه‌یِ
        مرکزیِ فیلسوف می پندارند، این کتاب تنها به مثابه لابی و سالنِ ورودی
        «Vorhalle» برای ساختمانِ فلسفی اوست (رجوع شود به کتابِ «تبارشناسیِ
        اخلاق» بخشِ سوم، پاره‌یِ ۲۷).
        <p dir="ltr" font-style="oblique">
          <cite>
            Ich habe mich nunmehr entschlossen, die nächsten fünf Jahre zur
            Ausarbeitung meiner «Philosophie» zu verwenden, für welche ich mir,
            durch meinen Zarathustra, eine Vorhalle gebaut habe.
            <br />
            (Brief an Overbeck in Basel - 1884)
          </cite>
        </p>
        فلسفه‌ی مرکزی و پروژه‌ی اصلیِ نیچه، کتابِ «اراده معطوف به قدرت» است. این
        اثر در زمانِ زندگانیِ نیچه، آماده‌ی چاپ نشد و متاسفانه پس از مرگ وی و به
        کوششِ خواهرِ فیلسوف، در دو مرحله گردآوری شده و به چاپ ِ نهایی رسید.
        محققان بر این باورند که خواهر فردریش نیچه در محتوای بخشی از یادداشت‌های
        مربوط به اراده‌ی معطوف به قدرت دخل و تصرف‌هایی را روا داشته است. اما
        ساختار کلی و چهارفصلیِ کتاب، نام‌گذاریِ فصل‌ها و طرح کلیِ تمامیِ
        گزینه‌گویه‌ها متعلق به خودِ فیلسوف می‌باشد از خطوطِ اصلیِ‌ اندیشه‌ی نیچه
        می‌توان به «خواستِ قدرت»، «بازگشتِ جاودان» و «ارزش‌گذاریِ دوباره‌ی همه‌ی
        ارزش‌ها» اشاره کرد. در این میان، کیشِ مسیحی، اخلاق و فلسفه از جمله
        مهم‌ترین کهنه-ارزش‌هایی به‌شمار می‌آیند که می‌بایستی باز-ارزش‌گذاری
        شوند. باید توجه داشت که این سه یعنی کیشِ مسیحی، اخلاق و فلسفه در خویشتنِ
        خویش به عنوانِ والاترینِ ارزش‌ها به شمار نمی‌آیند، بلکه تنها نقشِ زمینِ
        بازی و بسترِ تحققِ والاترینِ ارزش‌ها را ایفا می‌کنند و از این روی، خود
        نیز به عنوانِ والاترینِ ارزش‌ها مورد توجّه قرار می‌گیرند.
      </p>
    ),
  },
  {
    id: "0001",
    image:
      "https://images.pexels.com/photos/462023/pexels-photo-462023.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "Gott ist tot",
    text: (
      <p>
        <p dir="ltr">
          <cite>
            Wohin ist Gott? rief er, ich will es euch sagen! Wir haben ihn
            getödtet, – ihr und ich! Wir Alle sind seine Mörder! (Die fröhliche
            Wissenschaft)
          </cite>
        </p>
        خدا مرده است: در قرن‌هایِ هجدهم و نوزدهمِ میلادی، پیشرفتِ روزافزونِ
        دانش، وضعیتِ عمومیِ اروپا را به شکلی بنیادین، تحتِ تاثیرِ خود قرار
        می‌داد. در سرتاسرِ اروپا دانشگاه‌هایِ صنعتی‌ای تاسیس می‌شدند که وظیفه‌یِ
        ابزارسازی، برپایه‌ی نظریه‌های نوظهورِ علمی را برعهده گرفته بودند. این
        پیشرفت در علومِ تجربی، ستون‌های خود را در زمینِ علومِ انسانیِ عصرِ
        روشنگری می‌یافت. عصری که با فرانسیس بیکن، دکارت و ولتر آغاز شده بود، از
        مسیرِ ایده‌باوران و تجربه‌باوران به کانت رسیده و با شلینگ، هگل و
        شوپنهاور خود را در نیچه بازیافته بود. این پیشرفتِ همه‌جانبه‌یِ عملی و
        نظری، رمزگشاییِ دانش‌بنیادِ طبیعت و در نتیجه‌ی آن پاسخ‌های آزمایش‌- و
        ابطال‌پذیرِ علمی به پرسش‌هایی با قدمتی دوهزار ساله، اروپا را هرچه بیشتر
        از کلیسا و باورمندی به پاسخ‌های کلیسایی می‌رهانید. روحِ زمان، اینک
        درحالِ دگردیسیِ نوینی بود: اروپای مدرن. اروپای بی کلیسا. اروپایِ
        مثبت‌اندیشِ خداناباور.
        <p></p>
        مرگ خدا، نه شرحِ یک واقعه و پیشامد و نه یک مانیفستِ فلسفی برای گروهی خاص
        از خداناباوران، که بازنمودِ یک رَوند است. مرگِ خدا بازنمودِ روندی
        اجتماعی‌ست که یزدان‌های تاریخی غرب را در غروبِ خود می‌بیند. روندی که
        آهسته پیش‌آمده است و نرم نرمک و آرام، خورشیدِ باستانیِ اروپایی را در خود
        فرو بلعیده است: رَوندِ دورانِ مدرن.
        <p></p>
        مرگ خدا، شرحِ وضعیتِ اروپای قرنِ نوزدهم است. شرحِ دانش‌باوری و امید ِ
        شگرفی که انسانِ اروپایی در پاسخ‌ها و پیشرفت‌های علم‌بنیاد نهاده بود.
        آری، این روند، نه تنها پایانِ خداباوریِ فیلسوفانه و روشنفکرانه‌، که
        مهم‌تر از آن، پایانِ خداباوریِ عمومی، در اندیشه‌ی انسانِ اروپای‌ست.
        پایانی که با تیغِ تیزِ دانشمندان و مهندسانِ نوظهورِ دانش‌محور که بر
        شانه‌ی فیلسوفانِ عصرِ روشنگری ایستاده بودند، درحالِ رقم خوردن بود.
        خواهیم دید که نیچه، به عنوانِ میراث‌دارِ فلسفه‌ی بدبینانه‌ی شوپنهاور، پس
        از اعلامِ مرگِ خدا به عنوانِ وضعیتِ انسانِ معاصر، با نگاهی شکاکانه به
        اروپایی می‌نگرد که تمامی افق‌های تاریخیِ خویش را از صحنه‌ی روزگار «پاک»
        کرده است.
      </p>
    ),
  },
  {
    id: "0003",
    image:
      "https://images.pexels.com/photos/9989559/pexels-photo-9989559.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "Postmodernismus",
    text: (
      <p>
        پست مدرنیسم: مرگِ خدا در حقیقت، اشاره‌ به این نکته‌ است که الوهیتِ
        تاریخیِ اروپایی، زیرِ چاقویِ عصر روشنگری سر بریده شده است. جهانِ مدرن،
        جهانِ مثبت اندیش و خوش باوری‌‌ست که امیدی شگرف برعلومِ انسانی و تجربیِ
        خویش بسته است و با شوری وصف ناشدنی، براین گمان است که با پایانِ حاکمیتِ
        متافیزیکِ ارسطویی، اینک روشِ رمزگشایی و پاسخ‌گویی به تمامیِ پرسش‌ها را
        دریافته است. در مقابلِ این بینشِ مثبتِ مدرن، اندیشه‌ی پُست‌مدرن صف‌آرایی
        می‌کند که با نگاه‌ای منفی، شکاکانه و آکنده از تردید به این دیدگاهِ
        مثبت‌اندیشانه و امیدوارِ مدرن می‌نگرد.
        <p></p>
        گفتمانِ مرکزیِ اندیشه‌یِ پست‌مدرن در فلسفه‌ی نیچه، طرحِ این نظریه است که
        آنچه دورانِ مدرن با خود به ارمغان آورده است، زمینه‌سازِ سردرگمی، پریشانی
        و آشفتگیِ انسان معاصری است که سالیانی طولانی، خویشتنِ خویش را در افقی که
        کلیسا برای او ترسیم کرده بود می‌دیده است. اکنون اما، خورشید ِ فروزان و
        پیشینیِ یزدان پرستانه‌یِ دوران باستانی‌اش رو به خاموشی نهاده است و
        انسانِ معاصر در این تاریکی و تنگنای، با چشمانی فرو بسته به هر سوی به
        دنبال خورشیدی نوین و جایگزینی جدید، روان و دوان است.
        <p dir="ltr">
          <cite>
            Was thaten wir, als wir diese Erde von ihrer Sonne losketteten?
            Wohin bewegt sie sich nun? Wohin bewegen wir uns? Fort von allen
            Sonnen? Stürzen wir nicht fortwährend? Und rückwärts, seitwärts,
            vorwärts, nach allen Seiten? Giebt es noch ein Oben und ein Unten?
            Irren wir nicht wie durch ein unendliches Nichts? Haucht uns nicht
            der leere Raum an? Ist es nicht kälter geworden? Kommt nicht
            immerfort die Nacht und mehr Nacht? Müssen nicht Laternen am
            Vormittage angezündet werden? Hören wir noch Nichts von dem Lärm der
            Todtengräber, welche Gott begraben? Riechen wir noch Nichts von der
            göttlichen Verwesung? – auch Götter verwesen! Gott ist todt! Gott
            bleibt todt! Und wir haben ihn getödtet! Wie trösten wir uns, die
            Mörder aller Mörder? Das Heiligste und Mächtigste, was die Welt
            bisher besass, es ist unter unseren Messern verblutet, – wer wischt
            diess Blut von uns ab? Mit welchem Wasser könnten wir uns reinigen?
            Welche Sühnfeiern, welche heiligen Spiele werden wir erfinden
            müssen? Ist nicht die Grösse dieser That zu gross für uns? Müssen
            wir nicht selber zu Göttern werden, um nur ihrer würdig zu
            erscheinen? Es gab nie eine grössere That, – und wer nur immer nach
            uns geboren wird, gehört um dieser That willen in eine höhere
            Geschichte, als alle Geschichte bisher war!
            <br />
            (Die fröhliche Wissenschaft)
          </cite>
        </p>
      </p>
    ),
  },
];
